export default "__VITE_ASSET__D5lP8xco__"